var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.runScript}},[_vm._v("Run Python Script")])
}
var staticRenderFns = []

export { render, staticRenderFns }